import styled from 'styled-components';
import rightArrow from '../../images/policy/right-arrow.svg';
import OpdBackground from '../../images/newInsurerPage/OpdBg.svg';
import GmcBackground from '../../images/newInsurerPage/GmcBg.svg';
import ClaimsCardIconBackground from '../../images/newInsurerPage/claimscardiconBackground.svg';
import ClaimsCardIcon from '../../images/newInsurerPage/claimsCardIcon.svg';
import blueArrow from '../../images/newInsurerPage/blueArrow.svg';
import ClaimCardBg from '../../images/newInsurerPage/claimCardBg.svg';
import QuestionMarkIcon from '../../images/newInsurerPage/HelpQuestionmarkicon.svg';
import GoldenArrow from '../../images/newInsurerPage/goldenArrow.svg';
import ClaimSupportbg from '../../images/newInsurerPage/claimSupportbg.svg';
import headsetIcon from '../../images/newInsurerPage/headsetIcon.svg';
import headsetIconBg from '../../images/newInsurerPage/headsetbg.svg';
import EmailIcon from '../../images/newInsurerPage/emailIcon.svg';
import PhoneIcon from '../../images/newInsurerPage/phoneIcon.svg';
import Tappable from 'react-tappable/lib/Tappable';

const TappableCard = styled(Tappable)``;

const CardBody = styled.div`
  display: flex;
  //   justify-content: space-evenly;
  align-items: center;
  background: ${(props) => `url(${props.bgSvg})`},
    ${(props) => `${props.bgColor}`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  text-align: center;
  border: ${(props) => (props.borderColor ? '1px solid' : 'none')};
  border-image: ${(props) =>
    props.borderColor ? `${props.borderColor}` : 'none'};
  border-radius: 12px;
  padding: 15px 28px 15px 20px;
  margin-bottom: 1rem;
`;

const CardIcon = styled.img`
  // align-self: flex-start;
`;
const CardIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
  border-radius: 8px;
  overflow: hidden;
  height: 40px;
  width: 40px;
  background: ${(props) => `url(${props.bgSvg})`},
    ${(props) => `${props.bgColor}`};
`;

const CardDetails = styled.div`
  padding: 0px 18px 0px 20px;
  text-align: left;
  flex: 1;
`;

const CardTitle = styled.p`
  font-size: 16px;
  line-height: 21px;
  font-weight: 600;
  white-space: pre-wrap;
  margin-bottom: 8px;
  text-wrap: wrap;
  color: ${(props) => props.color};
`;

const CardSubtitle = styled.p`
  color: #171616;
  font-size: 10px;
  font-weight: 500;
  line-height: 150%; /* 15px */

  line-height: 15px;
  white-space: pre-wrap;
  color: ${(props) => props.titleColor};
  line-height: 20px;
`;
const CardSubtitleSpan = styled.span`
  font-size: 12px;

  line-height: 15px;
  font-weight: 600;
  white-space: pre-wrap;
  color: ${(props) => props.titleColor};
  line-height: 20px;
`;

const CardSubtitleType2 = styled.p`
  font-size: 10px;
  line-height: 15px;
  font-weight: 600;
  white-space: pre-wrap;
  color: #171616;
  line-height: 20px;
`;

const RightArrow = styled.img`
  filter: ${(props) => (props.filter ? `${props.filter}` : 'none')};
`;

const getBackground = (ThemeKey) => {
  switch (ThemeKey) {
    case 'opd-policy-1':
      return OpdBackground;
    case 'gmc-policy':
      return GmcBackground;
    case 'claimSupport':
      return ClaimSupportbg;
    default:
      return '';
  }
};
const getBackgroundColor = (ThemeKey) => {
  switch (ThemeKey) {
    case 'help':
      return '#FAE9D3';
    case 'claimSupport':
      return 'linear-gradient(136deg, #A7EAE5 0%, #CDFFFC 100%)';
    default:
      return '';
  }
};
const getTextColor = (ThemeKey) => {
  switch (ThemeKey) {
    case 'help':
      return '#C27D20';
    case 'claimSupport':
      return '#297166';
    default:
      return '';
  }
};
// const getArrow = (ThemeKey) => {
//   switch (ThemeKey) {
//     case 'claims':
//       return blueArrow;
//     default:
//       return '';
//   }
// };
const getIconBackground = (ThemeKey) => {
  switch (ThemeKey) {
    case 'claimSupport':
      return headsetIconBg;
    default:
      return '';
  }
};
const handleOnTap = (key, data) => {
  console.log('key', data);
  switch (key) {
    case 'phone':
      return (window.location.href = `tel:${data}`);
    case 'email':
      return (window.location.href = `mailto:${data}`);
    default:
      return '';
  }
};

const NewHelpCard = (props) => {
  return props.data.themeKey === 'help' ? (
    <Tappable onTap={props.onTap}>
      <CardBody
        bgSvg={''}
        borderColor=""
        bgColor={getBackgroundColor(props.data.themeKey)}
      >
        <CardIconContainer>
          <CardIcon src={QuestionMarkIcon} alt="icon" />
        </CardIconContainer>

        <CardDetails>
          <CardTitle color={getTextColor(props.data.themeKey)}>
            {props.data.title}
          </CardTitle>
          <CardSubtitle>{props.data.subTitle}</CardSubtitle>
        </CardDetails>
        <RightArrow src={GoldenArrow} filter={props.filter} />
      </CardBody>
    </Tappable>
  ) : (
    <OuterCard
      bgSvg={ClaimSupportbg}
      bgColor={getBackgroundColor(props.data.themeKey)}
    >
      <NewCard>
        <CardIconContainer bgColor="linear-gradient(129deg, #CDF1EF 0%, rgba(205, 241, 239, 0.00) 100%)">
          <CardIcon src={headsetIcon} alt="icon" />
        </CardIconContainer>

        <CardDetails>
          <NewCardTitle color={getTextColor(props.data.themeKey)}>
            {props.data.title}
          </NewCardTitle>
          <CardSubtitle>{props.data.subTitle}</CardSubtitle>
        </CardDetails>
      </NewCard>
      <ButtonContainer>
        <Button
          onTap={() => handleOnTap('email', props.data.emails[0])}
          bgColor="#FFF"
        >
          <ButtonSpan color="#297166">Email</ButtonSpan>
          <img src={EmailIcon} style={{ paddingRight: '35px' }} alt="" />
        </Button>
        <Button
          onTap={() => handleOnTap('phone', props.data.mobile)}
          bgColor="#65BFB1"
        >
          <ButtonSpan color="#FFF">Call</ButtonSpan>
          <img src={PhoneIcon} style={{ paddingRight: '35px' }} alt="" />
        </Button>
      </ButtonContainer>
    </OuterCard>
  );
};

export default NewHelpCard;

const NewCardTitle = styled.p`
  font-size: 16px;
  line-height: 21px;
  font-weight: 600;
  white-space: pre-wrap;
  text-wrap: wrap;
  color: ${(props) => props.color};
`;

const ButtonSpan = styled.span`
  padding-left: 35px;
  color: ${(props) => `${props.color}`};

  font-size: 12px;
  font-weight: 600;
`;

const Buttonicon = styled.img``;

const Button = styled(Tappable)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  width: 140px;
  height: 30px;
  background: ${(props) => `${props.bgColor}`};
  border-radius: 20px;
`;

const ButtonContainer = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
`;

const OuterCard = styled.div`
  margin-bottom: 1rem;
  border-radius: 12px;
  padding: 15px 28px 15px 20px;
  background: ${(props) => `url(${props.bgSvg})`},
    ${(props) => `${props.bgColor}`};
  //   background-repeat: no-repeat;
  //   background-size: cover;
  //   background-position: center;
  border: ${(props) => (props.borderColor ? '1px solid' : 'none')};
  border-image: ${(props) =>
    props.borderColor ? `${props.borderColor}` : 'none'};
`;

const NewCard = styled.div`
  display: flex;
  //   justify-content: space-evenly;
  align-items: center;
  text-align: center;
`;
// const CardBody = styled.div`
//   display: flex;
//   //   justify-content: space-evenly;
//   align-items: center;
//   background: ${(props) => `url(${props.bgSvg})`},
//     ${(props) => `${props.bgColor}`};
//   background-repeat: no-repeat;
//   background-size: cover;
//   background-position: center;
//   text-align: center;
//   border: ${(props) => (props.borderColor ? '1px solid' : 'none')};
//   border-image: ${(props) =>
//     props.borderColor ? `${props.borderColor}` : 'none'};
//   border-radius: 12px;
//   padding: 15px 28px 15px 20px;
//   margin-bottom: 1rem;
// `;
